import { useEffect, useState } from 'react'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query'

interface SerializedError {
  name?: string
  message?: string
  stack?: string
  code?: string
}

export const useRefetchAfterError = (
  refetchFunction: () => void,
  errorResponse?: FetchBaseQueryError | SerializedError,
) => {
  const [retryCount, setRetryCount] = useState(0)
  const [endpointFailed, setEndpointFailed] = useState(false)

  useEffect(() => {
    let timeoutId

    if (retryCount >= 2) {
      setEndpointFailed(true)
      return
    }

    if (errorResponse) {
      timeoutId = setTimeout(() => {
        setRetryCount(prevCount => prevCount + 1)
        refetchFunction()
      }, 1000)
    } else {
      setRetryCount(0)
    }
    return () => {
      clearTimeout(timeoutId)
    }
  }, [errorResponse, refetchFunction])

  return endpointFailed
}
